import { BookingDetailMapper } from "@app/core/booking/data/network/booking-detail.mapper";
import { MatchMapper } from "@app/core/match/data/network/match.mapper";
import { RecentData } from "@app/core/recent-data/domain/model/recent-data";

export class RecentDataMapper {
  static deserialize(response: any): RecentData {
    return {
      level: response.level
        ? {
            level_text: response.level.level_text,
            level_value: response.level.level_value,
            info_url: response.level.info_url,
            info_text: response.level.info_text,
            info_title: response.level.info_title,
            ranking_value: response.level.ranking_value,
            ranking_title: response.level.ranking_title,
            level_matches: response.level_matches,
            matches_before_level_launch: response.matches_before_level_launch,
            reduced_stats_matches: response.reduced_stats_matches,
            non_competitive_matches: response.non_competitive_matches,
            isLocked: response.level.isLocked,
          }
        : undefined,
      lastMatch: response.lastMatch
        ? {
            match: response.lastMatch.match
              ? MatchMapper.deserialize(response.lastMatch.match)
              : null,
            matchRequest: response.lastMatch.matchRequest
              ? BookingDetailMapper.deserialize(response.lastMatch.matchRequest)
              : null,
          }
        : undefined,
      objectives: response.objectives
        ? {
            section_id: "objectives",
            stat_type: "list",
            list_items: [
              {
                type: "objectives",
                list: response.objectives[0].subsection_content.list_items,
              },
            ],
          }
        : undefined,
      clubs: response.clubs.length > 0 ? response.clubs : undefined,
    };
  }
}
